import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom'
import { matchPath } from 'react-router'
import { Row, Col, Nav, TabContent } from 'reactstrap'
import LicenseRouter from 'containers/css-admin/licenses'
import SitesManager from 'containers/sites'
import UserManager from 'containers/css-admin/users'
import ContractLineRouter from 'containers/css-admin/contractLines'
import UtilitiesLayout from 'containers/css-admin/utilities'
import PakUploadContainer from 'containers/css-admin/pakUpload/PakUploadContainer'
import { AdminNavBarItem, DeleteAccountModal } from 'components'
import { RootState } from 'types'
import {
  DeleteAccountActionWrapper,
  DeleteAccountButton,
} from './CssAdmin.styles'

interface CssAdminProps {
  isCssAdmin: boolean
  isOperationsAdmin: boolean
  isTechnologyAdmin: boolean
  showFooter: (show: boolean) => void
}

interface LeftNavLinksProps {
  isCssAdmin: boolean
  isTechnologyAdmin: boolean
  path: string
}

interface RightNavLinksProps {
  isCssAdmin: boolean
  isOperationsAdmin: boolean
  isTechnologyAdmin: boolean
  path: string
}

const CssAdmin: React.FC<CssAdminProps> = ({
  isCssAdmin,
  isOperationsAdmin,
  isTechnologyAdmin,
  showFooter,
}) => {
  const location = useLocation()
  const match = useRouteMatch()
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false)

  const productUser = useSelector<RootState, any>(
    state => state.userManager?.productUser,
  )

  useEffect(() => {
    showFooter(false)
  }, [showFooter])

  const onCloseModal = () => setShowDeleteAccountModal(false)
  const onShowModal = () => setShowDeleteAccountModal(true)

  const matchUserProfile = matchPath(location.pathname, {
    path: `${match.path}/users/:email/:id`,
    exact: true,
    strict: true,
  })

  if (match.isExact) {
    if (isCssAdmin || isTechnologyAdmin) {
      return (
        <Redirect exact from={`${match.path}`} to={`${match.path}/licenses`} />
      )
    } else if (isOperationsAdmin) {
      return <Redirect exact from={`${match.path}`} to={`${match.path}/pak`} />
    } else {
      return <Redirect exact from={`${match.path}`} to={`${match.path}`} />
    }
  }

  return (
    <>
      <Row className="no-gutters">
        <Col className="col-auto">
          <LeftNavLinks
            isCssAdmin={isCssAdmin}
            isTechnologyAdmin={isTechnologyAdmin}
            path={match.path as string}
          />
        </Col>
        <Col className="end">
          <RightNavLinks
            isCssAdmin={isCssAdmin}
            isOperationsAdmin={isOperationsAdmin}
            isTechnologyAdmin={isTechnologyAdmin}
            path={match.path as string}
          />
        </Col>
      </Row>
      <TabContent
        className="tab-content-bordered"
        style={{ borderWidth: '0 1px 1px' }}
      >
        {(isCssAdmin || isTechnologyAdmin) && (
          <>
            <Route component={LicenseRouter} path={`${match.path}/licenses`} />
            <Route component={UserManager} path={`${match.path}/users`} />
            <Route
              component={ContractLineRouter}
              path={`${match.path}/contractLine`}
            />
            <Route component={SitesManager} path={`${match.path}/sites`} />
            <Route
              component={UtilitiesLayout}
              path={`${match.path}/utilities`}
            />
          </>
        )}
        <Route component={PakUploadContainer} path={`${match.path}/pak`} />
      </TabContent>
      {matchUserProfile && productUser && (
        <DeleteAccountActionWrapper>
          <DeleteAccountButton onClick={onShowModal}>
            <i className="fas fa-trash-alt" /> Delete Account
          </DeleteAccountButton>
        </DeleteAccountActionWrapper>
      )}
      {showDeleteAccountModal && (
        <DeleteAccountModal
          isModalOpen={showDeleteAccountModal}
          onCloseModal={onCloseModal}
        />
      )}
    </>
  )
}

const LeftNavLinks: React.FC<LeftNavLinksProps> = ({
  isCssAdmin,
  isTechnologyAdmin,
  path,
}) => (
  <>
    {(isCssAdmin || isTechnologyAdmin) && (
      <Nav tabs>
        <AdminNavBarItem
          endpoint={path + '/licenses'}
          id="licenses"
          name="Licenses"
        />
        <AdminNavBarItem endpoint={path + '/sites'} id="sites" name="Sites" />
        <AdminNavBarItem endpoint={path + '/users'} id="users" name="Users" />
        <AdminNavBarItem
          endpoint={path + '/contractLine'}
          id="contractLine"
          name="Contract Lines"
        />
        <AdminNavBarItem
          endpoint={path + '/utilities'}
          id="utilities"
          name="Utilities"
        />
      </Nav>
    )}
  </>
)

const RightNavLinks: React.FC<RightNavLinksProps> = ({ path }) => (
  <Nav className="justify-content-end" tabs>
    <AdminNavBarItem
      endpoint={path + '/pak'}
      icon="fas fa-file-upload"
      id="pak"
      name="Upload PAK Codes"
    />
    {/* {(isCssAdmin || isTechnologyAdmin) && (
      <AdminNavBarItem
        endpoint={path + '/reports'}
        icon="fas fa-table"
        id="reports"
        name="Reports"
      />
    )} */}
  </Nav>
)

export default CssAdmin
